import * as ActionTypes from '../../actions/allActions'

const initialState = { show: false, messages: {}, currentRequests: [] }
const spinner = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.SHOW_SPINNER:
			return {
				show: true, messages: { ...state.messages, [action.requestId]: action.mess },
				currentRequests: [...state.currentRequests, action.requestId]
			}
		case ActionTypes.HIDE_SPINNER:
			let newCurrentRequest = state.currentRequests.filter(e => e !== action.requestId)
			let shouldShow = false;
			let newMessages = { ...state.messages }
			delete newMessages[action.requestId]
			if (newCurrentRequest.length > 0) {
				shouldShow = true
			}
			return { show: shouldShow, messages: newMessages, currentRequests: newCurrentRequest }
		case ActionTypes.LOGOUT:
			return initialState
		default:
			return state
	}
}

export default spinner


// WEBPACK FOOTER //
// ./src/reducers/ui/spinner.js